import {
  Component,
} from '@angular/core';


@Component({
  selector: 'app-flights-form',
  templateUrl: './flights-form.component.html',
  styleUrls: ['./flights-form.component.css']
})
export class FlightsFormComponent {

}